import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService, ContextService } from '../shared';


@Component({
  selector: 'cms',
  templateUrl: './cms.component.html',
  styleUrls: ['./cms.component.scss']
})
export class CmsComponent implements OnInit {
  
  page: any = {};
  blocs: any = [];
  slug:string = "";
  context: string;

  constructor(
  	private route: ActivatedRoute,
  	private router: Router,
     private contextService: ContextService,
    private homeService: HomeService) { 
     window.scrollTo(0, 0);

  }

  ngOnInit(): void {
     this.context = this.contextService.getContext();
  	this.getPage();
  }

  getPage(): void {
  	this.slug = this.route.snapshot.data.slug+'/';
   	if(this.slug) this.homeService.getPage(this.slug)
  	  .subscribe(page => {
        console.log(page)
        this.page = page;
        this.blocs = page.blocs;
      });
  }

  scrollTop(){
    window.scrollTo(0, 0);
  }

}



// WEBPACK FOOTER //
// ./src/app/cms/cms.component.ts